import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { z } from "zod";
import { useForgotPasswordMutation } from "../lib/api/auth";

const forgotSchema = z.object({
  email: z.email("Enter a valid email address"),
});

type ForgotFormValues = z.infer<typeof forgotSchema>;

export function ForgotPasswordPage() {
  const forgot = useForgotPasswordMutation();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<ForgotFormValues>({
    resolver: zodResolver(forgotSchema),
    defaultValues: { email: "" },
  });

  const onSubmit = handleSubmit(async (values) => {
    await forgot.mutateAsync(values);
  });

  return (
    <div className="flex min-h-screen items-center justify-center bg-edlab-bg px-4">
      <div className="w-full max-w-md rounded-2xl border border-edlab-line bg-white p-8 shadow-sm">
        <h1 className="text-2xl font-semibold text-edlab-ink">Reset password</h1>
        <p className="mt-2 text-sm text-edlab-muted">
          Enter your email and we will send reset instructions if an account exists.
        </p>

        {forgot.isSuccess ? (
          <p className="mt-6 rounded-lg border border-edlab-line bg-edlab-bg px-3 py-3 text-sm text-edlab-ink">
            {forgot.data.message}
          </p>
        ) : (
          <form className="mt-6 grid gap-4" onSubmit={(event) => void onSubmit(event)}>
            <label className="grid gap-2 text-sm">
              Email
              <input
                type="email"
                className="edlab-input"
                {...register("email")}
              />
              {errors.email ? (
                <span className="text-xs text-red-600">{errors.email.message}</span>
              ) : null}
            </label>
            <button
              type="submit"
              disabled={isSubmitting || forgot.isPending}
              className="rounded-lg bg-edlab-green px-4 py-2.5 text-sm font-medium text-white hover:bg-edlab-green-dark disabled:opacity-50"
            >
              Send reset link
            </button>
          </form>
        )}

        <p className="mt-6 text-center text-sm">
          <Link to="/login" className="text-edlab-green hover:underline">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
